import React from 'react'

export default function Awards() {
  return (
    <section className="resume-section" id="awards">
          <div className="resume-section-content">
            <h2 className="mb-5">Awards &amp; Certifications</h2>
            <ul className="fa-ul mb-0">
              <li>
                <span className="fa-li"><i className="fas fa-trophy text-warning" /></span>
                <b>1
                <sup>st</sup></b>
                 Top Performer in Master in Computer Apllications (MCA)
              </li>
              <li>
                <span className="fa-li"><i className="fas fa-trophy text-warning" /></span>
                <b>Excellency Award </b>- I am excited to share that I was awarded the "Excellency" award for being the top-performing web development team employee at HARMAN in 2017. Being recognized for my commitment and hard work towards the company's success was an honour.
              </li>
              <li>
                <span className="fa-li"><i className="fas fa-trophy text-warning" /></span>
                <b>Bravo Award </b>- I am proud to share that I won the "Bravo Award!" for being the best employee in the team for implementing the new CI Dashboard for our client DODGE in 2018. It was challenging, but I am glad I Contributed to the project's success.
              </li>
              <li>
                <span className="fa-li"><i className="fas fa-trophy text-warning" /></span>
                <b>Inspire & Achieve Excellence </b>- Team and Focused Work for FISERV earned the "Inspire & Achieve Excellence" award in 2019 and 2020.
              </li>
              
            </ul>
          </div>
        </section>
  )
}
